import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";
import axios from "axios";
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faSync, faChartLine, faRupeeSign, faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import moment from 'moment';
import "./DailyReport.css";
ChartJS.register(...registerables);

/* React-Select: same font size (10px) and font as other filter dropdowns */
const selectFont = {
  fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  fontSize: 10,
  lineHeight: 1.2,
};

const selectStyles = {
  control: (base, state) => ({
    ...base,
    ...selectFont,
    minHeight: 28,
    height: 28,
    overflow: "visible",
    background: "var(--bg-secondary)",
    borderColor: state.isFocused ? "var(--accent-primary)" : "var(--border-color)",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(6, 182, 212, 0.2)" : "none",
    "&:hover": { borderColor: "var(--accent-primary)" },
  }),
  valueContainer: (base) => ({
    ...base,
    ...selectFont,
    overflow: "visible",
    padding: "2px 6px",
    height: "100%",
    alignItems: "center",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0 4px",
    alignSelf: "stretch",
  }),
  menu: (base) => ({
    ...base,
    ...selectFont,
    background: "var(--bg-card)",
    border: "1px solid var(--border-color)",
    borderRadius: "var(--radius-sm)",
    boxShadow: "var(--shadow-lg)",
    zIndex: 9999,
  }),
  menuList: (base) => ({
    ...base,
    padding: 4,
    background: "var(--bg-card)",
  }),
  option: (base, state) => ({
    ...base,
    ...selectFont,
    background: state.isFocused ? "var(--bg-card-hover)" : "var(--bg-card)",
    color: "var(--text-primary)",
    cursor: "pointer",
    padding: "3px 8px",
  }),
  input: (base) => ({
    ...base,
    ...selectFont,
    color: "var(--text-primary)",
  }),
  placeholder: (base) => ({
    ...base,
    ...selectFont,
    color: "var(--text-muted)",
  }),
  singleValue: (base) => ({
    ...base,
    ...selectFont,
    color: "var(--text-primary)",
  }),
};

class DailyReport extends Component { 
  state = {
    API_URL: process.env.REACT_APP_API_ENDPOINT
      ? process.env.REACT_APP_API_ENDPOINT.replace(/\/+$/, "") + "/"
      : "",
    ph: false,
    indexName: "all_expiry",
    trading_session: "all",
    opening_type: "all",
    algoName: "CHEETAH_IOS",
    tradeType: "paper",
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    dayName: "ALL",
    exDay: "ALL",
    chartData: {
      datasets: [
        {
          label: "OPTION SELL Profit %",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.2)",
          borderWidth: 1,
          borderColor: "rgba(255, 99, 132, 1)",
        },
      ],
    },
    chartWinLossData: {
      labels: "Win/Loss",
      datasets: [
        {
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.2)",
          borderWidth: 1,
          borderColor: "rgba(255, 99, 132, 1)",
        },
        {
          data: [],
          backgroundColor: "rgba(153, 102, 255, 0.2)",
          borderColor: "rgba(153, 102, 255, 1)",
          borderWidth: 1,
        },
      ],
    },
    profitChart: {
      labels: "Profit",
      datasets: [
        {
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.2)",
          borderWidth: 1,
          borderColor: "rgba(255, 99, 132, 1)",
        },
        {
          data: [],
          backgroundColor: "rgba(153, 102, 255, 0.2)",
          borderColor: "rgba(153, 102, 255, 1)",
          borderWidth: 1,
        },
      ],
    },

    chartMaxProfitLoss: {
      labels: "PNL",
      datasets: [
        {
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.2)",
          borderWidth: 1,
          borderColor: "rgba(255, 99, 132, 1)",
        },
        {
          data: [],
          backgroundColor: "rgba(153, 102, 255, 0.2)",
          borderColor: "rgba(153, 102, 255, 1)",
          borderWidth: 1,
        },
      ],
    },
    kpi: {
      totalReturnPct: 0,
      totalProfit: 0,
      winRate: 0,
      maxLoss: 0,
    },
  };



  serializeParam = (val) => (Array.isArray(val) ? val.join(",") : val);

  componentDidMount() {
    this.getReportData();
  }

  generateReport = () => {
    const { indexName, algoName, tradeType, year, month, API_URL, trading_session, opening_type, ph, exDay } = this.state;
    const indexParam = this.serializeParam(indexName);
    const exDayParam = this.serializeParam(exDay);
    const url = API_URL + `api/monthly_generate_report?indexName=${encodeURIComponent(indexParam)}&tradeType=${tradeType}&algoName=${algoName}&year=${year}&month=${month}&trading_session=${trading_session}&opening_type=${opening_type}&ph=${ph}&exDay=${encodeURIComponent(exDayParam)}`;
    axios
      .get(url)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getReportData = () => {
    const { indexName, algoName, tradeType, year, month, dayName, exDay, API_URL, trading_session, opening_type, ph } = this.state;
    const indexParam = this.serializeParam(indexName);
    const exDayParam = this.serializeParam(exDay);
    const url = API_URL + `api/daily?indexName=${encodeURIComponent(indexParam)}&tradeType=${tradeType}&algoName=${algoName}&year=${year}&month=${month}&dayName=${dayName}&exDay=${encodeURIComponent(exDayParam)}&trading_session=${trading_session}&opening_type=${opening_type}&ph=${ph}`;
    axios
      .get(url)
      .then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : [];
        this.setReturnPercantage(list);
        this.setWinLossCountDate(list);
        this.setChartProfitDate(list);
        this.setpnlbar(list);
        this.setKpiFromData(list);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getReportByExDay = () => {
    const { indexName, algoName, tradeType, year, month, exDay, API_URL, trading_session, opening_type, ph } = this.state;
    const indexParam = this.serializeParam(indexName);
    const exDayParam = this.serializeParam(exDay);
    const url = API_URL + `api/dailyByListOfExDate?indexName=${encodeURIComponent(indexParam)}&tradeType=${tradeType}&algoName=${algoName}&year=${year}&month=${month}&exDay=${encodeURIComponent(exDayParam)}&trading_session=${trading_session}&opening_type=${opening_type}&ph=${ph}`;
    axios
      .get(url)
      .then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : [];
        this.setReturnPercantage(list);
        this.setWinLossCountDate(list);
        this.setChartProfitDate(list);
        this.setpnlbar(list);
        this.setKpiFromData(list);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  setKpiFromData = (data) => {
    const list = Array.isArray(data) ? data : [];
    if (list.length === 0) {
      this.setState({ kpi: { totalReturnPct: 0, totalProfit: 0, winRate: 0, maxLoss: 0 } });
      return;
    }
    let totalReturnPct = 0;
    for (let i = 0; i < list.length; i++) {
      const obj = list[i];
      const capital = Number(obj.capital);
      const totalProfitDay = Number(obj.total_profit);
      if (capital && capital !== 0 && Number.isFinite(totalProfitDay)) {
        const pct = (totalProfitDay / capital) * 100;
        totalReturnPct += Number.isFinite(pct) ? pct : 0;
      }
    }
    totalReturnPct = Number.isFinite(totalReturnPct) ? Math.round(totalReturnPct * 100) / 100 : 0;
    const totalProfit = list.reduce(
      (sum, obj) => sum + (Number(obj.profit) || 0) + (Number(obj.loss) || 0),
      0
    );
    const totalWins = list.reduce((sum, obj) => sum + (Number(obj.trade_win_count) || 0), 0);
    const totalLosses = list.reduce((sum, obj) => sum + (Number(obj.trade_loss_count) || 0), 0);
    const totalTrades = totalWins + totalLosses;
    const winRate = totalTrades > 0 ? Math.round((totalWins / totalTrades) * 100) : 0;
    const maxLossValues = list.map((obj) => Number(obj.max_loss)).filter(Number.isFinite);
    const maxLoss = maxLossValues.length ? Math.min(...maxLossValues) : 0;
    this.setState({
      kpi: {
        totalReturnPct,
        totalProfit: Number.isFinite(totalProfit) ? totalProfit : 0,
        winRate,
        maxLoss: Number.isFinite(maxLoss) ? maxLoss : 0,
      },
    });
  };

   setpnlbar = (data) => {
    // map over the array of objects and extract label and data values
   const labels = data.map((obj) => new Date(obj.date_milli).getDate());
   const live_profit = data.map((obj) => ((obj.live_profit/obj.capital)*100).toFixed(2));
   const max_loss = data.map((obj) => ((obj.max_loss/obj.capital)*100).toFixed(2));
   const max_profit = data.map((obj) => ((obj.max_profit/obj.capital)*100).toFixed(2));
    this.setState({
      chartMaxProfitLoss: {
        labels: labels,
        datasets: [
          {
            data: live_profit,
            type: "bar",
            label: "Live profit",
            borderWidth: 1,
            backgroundColor: (context) => {
              return context.dataset.data[context.dataIndex] > 0
                ? "green"
                : "red";
            },
            borderColor: (context) => {
              return context.dataset.data[context.dataIndex] > 0
                ? "green"
                : "red";
            },
          },
          {
            data: max_profit,
            type: "bar",
            label: "Max profit",
            borderWidth: 1,
            backgroundColor: (context) => {
              return context.dataset.data[context.dataIndex] > 0
                ? "green"
                : "red";
            },
            borderColor: (context) => {
              return context.dataset.data[context.dataIndex] > 0
                ? "green"
                : "red";
            },
          },
          {
            data: max_loss,
            type: "bar",
            label: "Max loss",
            borderWidth: 1,
            backgroundColor: (context) => {
              return context.dataset.data[context.dataIndex] > 0
                ? "green"
                : "red";
            },
            borderColor: (context) => {
              return context.dataset.data[context.dataIndex] > 0
                ? "green"
                : "red";
            },
          },
         
        ],
      },
    });
  };

  setReturnPercantage = (data) => {
    const days = ['Sun', 'M', 'T', 'W', 'Th', 'F', 'Sa'];
   const labels = data.map((obj) =>  [new Date(obj.date_milli).getDate() +":"+days[new Date(obj.date_milli).getDay()],"("+obj.ex_day +")",obj.opening_type]);

    const chartData = data.map((obj) => parseFloat(((obj.total_profit/obj.capital)*100).toFixed(2)));
    const runningSum = chartData.reduce(
      (a, x, i) => [...a, x + (a[i - 1] || 0)],
      []
    );
    const sum = chartData.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    this.setState({
      chartData: {
        labels: labels,
        datasets: [
          {
            data: chartData,
            type: "bar",
            label: "OPTION SELL Profit %",
            borderWidth: 1,
            backgroundColor: (context) => {
              return context.dataset.data[context.dataIndex] > 0
                ? "green"
                : "red";
            },
            borderColor: (context) => {
              return context.dataset.data[context.dataIndex] > 0
                ? "green"
                : "red";
            },
          },
          {
            type: "line",
            label: "Total Return " + sum + "%",
            data: runningSum,
            backgroundColor: "rgb(255,255,0)",
            borderColor: "rgb(255,255,0)",
            borderWidth: 1,
          },
        ],
      },
    });
  };
  setWinLossCountDate = (data) => {
    const labels = data.map((obj) => new Date(obj.date_milli).getDate());
    const winCount = data.map((obj) => obj.trade_win_count);
    const lossCount = data.map((obj) => obj.trade_loss_count);
    const chartWinLossDataTotal = data.map(
      (obj) => obj.trade_win_count + -1 * obj.trade_loss_count
    );
    const totalCount = data.map(
      (obj) => obj.trade_win_count + obj.trade_loss_count
    );
    this.setState({
      chartWinLossData: {
        labels: labels,
        datasets: [
          {
            type: "bar",
            data: winCount,
            label: "OPTION SELL WIN COUNT/",
            backgroundColor: "RGB(0, 68, 0)",
            borderWidth: 1,
            borderColor: "RGB(0, 68, 0)",
          },
          {
            type: "bar",
            label: "OPTION SELL LOSS COUNT",
            data: lossCount,
            backgroundColor: "#990000",
            borderColor: "#990000",
            borderWidth: 1,
          },
          {
            type: "bar",
            label: "Total Win Count",
            data: chartWinLossDataTotal,
            borderWidth: 1,
            backgroundColor: (context) => {
              return context.dataset.data[context.dataIndex] > 0
                ? "green"
                : "red";
            },
            borderColor: (context) => {
              return context.dataset.data[context.dataIndex] > 0
                ? "green"
                : "red";
            },
          },
          {
            type: "line",
            label: "Total Count",
            data: totalCount,
            backgroundColor: "#000000",
            borderColor: "#000000",
            borderWidth: 1,
          },
        ],
      },
    });
  };

  setChartProfitDate = (data) => {
    const labels = data.map((obj) => new Date(obj.date_milli).getDate());
    const profit = data.map((obj) => obj.profit);
    const loss = data.map((obj) => -1 * obj.loss);
    const totalProfit = data.map((obj) => obj.profit + obj.loss);
    const runningSum = totalProfit.reduce(
      (a, x, i) => [...a, x + (a[i - 1] || 0)],
      []
    );
    const sum = totalProfit.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    this.setState({
      profitChart: {
        labels: labels,
        datasets: [
          {
            type: "bar",
            data: profit,
            label: "Profit",
            backgroundColor: "RGB(0, 68, 0)",
            borderWidth: 1,
            borderColor: "RGB(0, 68, 0)",
          },
          {
            type: "bar",
            label: "Loss",
            data: loss,
            backgroundColor: "#990000",
            borderColor: "#990000",
            borderWidth: 1,
          },
          {
            type: "bar",
            label: "Total Profit Day= ",
            data: totalProfit,
            backgroundColor: (context) => {
              return context.dataset.data[context.dataIndex] > 0
                ? "green"
                : "red";
            },
            borderColor: (context) => {
              return context.dataset.data[context.dataIndex] > 0
                ? "green"
                : "red";
            },
            borderWidth: 1,
          },
          {
            type: "line",
            label: "Total Profit = " + sum,
            data: runningSum,
            backgroundColor: "#000000",
            borderColor: "#000000",
            borderWidth: 1,
          },
        ],
      },
    });
  };

  handleIndexNameChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : "all_expiry";
    this.setState({ indexName: value }, () => {
      this.getReportByExDay();
    });
  };

  tradingSessionChange = (event) => {
    this.setState({ trading_session: event.target.value }, () => {
      this.getReportData();
    });
  };

    openingTypeChange = (event) => {
    this.setState({ opening_type: event.target.value }, () => {
      this.getReportData();
    });
  };

  


  handleAlgoNameChange = (event) => {
    this.setState({ algoName: event.target.value }, () => {
      this.getReportData();
    });
  };

  handleTradeTypeChange = (event) => {
    this.setState({ tradeType: event.target.value }, () => {
      this.getReportData();
    });
  };

  handleYearChange = (event) => {
    this.setState({ year: event.target.value }, () => {
      this.getReportData();
    });
  };

  handleMonthChange = (event) => {
    this.setState({ month: event.target.value }, () => {
      this.getReportData();
    });
  };

  handleYearChangeVal = (value) => {
    this.setState({ year: value }, () => {
      this.getReportData();
    });
  };

  handleMonthChangeVal = (value) => {
    this.setState({ month: value }, () => {
      this.getReportData();
    });
  };

  handleDayNameChange = (event) => {
    this.setState({ dayName: event.target.value }, () => {
      this.getReportData();
    });
  };

  getExDaySelectValue = (options) => {
    const exDay = this.state.exDay;
    const val = Array.isArray(exDay) ? exDay[0] : exDay;
    return options.find((opt) => opt.value === val) || null;
  };

  getIndexSelectValue = (indices) => {
    const iname = this.state.indexName;
    const val = Array.isArray(iname) ? iname[0] : iname;
    return indices.find((opt) => opt.value === val) || null;
  };

  handleExDayChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : "ALL";
    this.setState({ exDay: value }, () => {
      this.getReportByExDay();
    });
  };


  handlePhChange = (event) => {
    const isChecked = event.target.checked;
    this.setState({ ph: isChecked });
  };

  render() {
    const indices = [
    { value: 'all_expiry', label: 'ALL EXPIRY' },
    { value: 'NIFTY 50', label: 'NIFTY' },
    { value: 'NIFTY BANK', label: 'Bank Nifty' },
    { value: 'NIFTY FIN SERVICE', label: 'Fin Nifty' },
    { value: 'SENSEX', label: 'SENSEX' },
    { value: 'BANKEX', label: 'BANKEX' },
    { value: 'NIFTY MID SELECT', label: 'MIDCPNIFTY' }
  ];
     const options = [
    { value: "ALL", label: "ALL DAYS" },
    { value: "0", label: "0" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "nonExpiryDay", label: "Non Expiry Day" },
  ];

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: { top: 6, right: 6, bottom: 6, left: 6 },
      },
      plugins: {
        legend: {
          position: "top",
          fullSize: true,
          labels: {
            color: "var(--text-primary)",
            font: { size: 11 },
            boxWidth: 14,
            boxHeight: 14,
            padding: 10,
          },
        },
      },
      scales: {
        x: {
          ticks: { color: "var(--text-secondary)", maxRotation: 45, font: { size: 10 } },
          grid: { color: "var(--border-color)" },
        },
        y: {
          ticks: { color: "var(--text-secondary)", font: { size: 10 } },
          grid: { color: "var(--border-color)" },
          grace: "8%",
        },
      },
    };

    return (
      <div className="daily-report">
        <section className="daily-report__filters" aria-label="Report filters">
          <div className="daily-report__filter-group">
            <span className="filter-label">Year</span>
            <select
              value={this.state.year}
              onChange={this.handleYearChange}
            >
              <option value="2018">2018</option>
              <option value="2019">2019</option>
              <option value="2020">2020</option>
              <option value="2021">2021</option>
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
            </select>
          </div>

          <div className="daily-report__filter-group">
            <span className="filter-label">Month</span>
            <select
              value={this.state.month}
              onChange={this.handleMonthChange}
            >
              <option value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
          </div>

          <div className="daily-report__filter-group">
            <span className="filter-label">Day</span>
            <select
              value={this.state.dayName}
              onChange={this.handleDayNameChange}
            >
              <option value="ALL">ALL</option>
              <option value="MONDAY">Monday</option>
              <option value="TUESDAY">Tuesday</option>
              <option value="WEDNESDAY">Wednesday</option>
              <option value="THURSDAY">Thursday</option>
              <option value="FRIDAY">Friday</option>
            </select>
          </div>

          <div className="daily-report__filter-group">
            <span className="filter-label">Ex Day</span>
            <div className="daily-report__select-wrap">
              <Select
                classNamePrefix="daily-report__select"
                value={this.getExDaySelectValue(options)}
                onChange={this.handleExDayChange}
                options={options}
                placeholder="Ex day..."
                styles={selectStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuPlacement="auto"
                isClearable
                aria-label="Ex day / prediction grade"
              />
            </div>
          </div>

          <div className="daily-report__filter-group">
            <span className="filter-label">Index</span>
            <div className="daily-report__select-wrap">
              <Select
                classNamePrefix="daily-report__select"
                value={this.getIndexSelectValue(indices)}
                onChange={this.handleIndexNameChange}
                options={indices}
                placeholder="Index..."
                styles={selectStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuPlacement="auto"
                isClearable
                aria-label="Index name"
              />
            </div>
          </div>

          <div className="daily-report__filter-group">
            <span className="filter-label">Session</span>
            <select
              value={this.state.trading_session}
              onChange={this.tradingSessionChange}
            >
              <option value="all">All</option>
              <option value="first">First</option>
              <option value="second">Second</option>
              <option value="third">Third</option>
            </select>
          </div>

          <div className="daily-report__filter-group">
            <span className="filter-label">Opening</span>
            <select
              value={this.state.opening_type}
              onChange={this.openingTypeChange}
            >
              <option value="all">All</option>
              <option value="SW">Sideways</option>
              <option value="GU">Gap Up</option>
              <option value="GD">Gap Down</option>
            </select>
          </div>

          <div className="daily-report__filter-group">
            <span className="filter-label">Algo</span>
            <select
              value={this.state.algoName}
              onChange={this.handleAlgoNameChange}
            >
              <option value="CHEETAH_IOS">CHEETAH_IOS</option>
              <option value="NON_DIRECTION">NON DIRECTION</option>
              <option value="NON_DIRECTION_BTST">NON DIRECTION BTST</option>
              <option value="DIRECTION_BTST">DIRECTION BTST</option>
              <option value="DIRECTION_POSITIONAL">DIRECTION POSITIONAL</option>
              <option value="NON_DIRECTION_POSITIONAL">NON DIRECTION POSITIONAL</option>
            </select>
          </div>

          <div className="daily-report__filter-group">
            <span className="filter-label">Type</span>
            <select
              value={this.state.tradeType}
              onChange={this.handleTradeTypeChange}
            >
              <option value="live">Live</option>
              <option value="paper">Paper</option>
            </select>
          </div>

          <div className="daily-report__actions">
            <button type="button" className="daily-report__btn-generate" onClick={() => this.generateReport()} title="Generate Report">
              <FontAwesomeIcon icon={faBolt} className="daily-report__btn-icon" />
              Generate
            </button>
            <button type="button" className="daily-report__btn-refresh" onClick={() => this.getReportData()} title="Refresh">
              <FontAwesomeIcon icon={faSync} className="daily-report__btn-icon" />
              Refresh
            </button>
          </div>

          <div className="daily-report__nav-buttons">
            <button type="button" onClick={() => this.handleYearChangeVal(this.state.year - 1)} aria-label="Previous year">←</button>
            <button type="button" onClick={() => this.handleYearChangeVal(this.state.year + 1)} aria-label="Next year">→</button>
            <button
              type="button"
              onClick={() => {
                this.handleMonthChangeVal(this.state.month < 2 ? 12 : this.state.month - 1);
                if (this.state.month < 2) this.handleYearChangeVal(this.state.year - 1);
              }}
              aria-label="Previous month"
            >
              ←
            </button>
            <button
              type="button"
              onClick={() => {
                this.handleMonthChangeVal(this.state.month > 11 ? 1 : this.state.month + 1);
                if (this.state.month > 11) this.handleYearChangeVal(this.state.year + 1);
              }}
              aria-label="Next month"
            >
              →
            </button>
          </div>
        </section>

        <div className="daily-report__charts-wrapper">
          <div className="daily-report__charts">
          <div className="daily-report__chart-card">
            <h3 className="daily-report__chart-title">Option Sell Profit %</h3>
            <p className="daily-report__chart-subtitle">Cumulative performance by trading day</p>
            <div className="chart-container">
              <Bar data={this.state.chartData} options={chartOptions} />
            </div>
          </div>
          <div className="daily-report__chart-card">
            <h3 className="daily-report__chart-title">Daily P&L Breakdown</h3>
            <p className="daily-report__chart-subtitle">Live profit vs max profit vs max loss</p>
            <div className="chart-container">
              <Bar data={this.state.chartMaxProfitLoss} options={chartOptions} />
            </div>
          </div>
          <div className="daily-report__chart-card">
            <h3 className="daily-report__chart-title">Trade Count Analysis</h3>
            <p className="daily-report__chart-subtitle">Win vs loss count per day</p>
            <div className="chart-container">
              <Bar data={this.state.chartWinLossData} options={chartOptions} />
            </div>
          </div>
          <div className="daily-report__chart-card">
            <h3 className="daily-report__chart-title">Cumulative Profit (₹)</h3>
            <p className="daily-report__chart-subtitle">Daily profit accumulation trend</p>
            <div className="chart-container">
              <Bar data={this.state.profitChart} options={chartOptions} />
            </div>
          </div>
        </div>
        </div>

        <section className="daily-report__kpi" aria-label="Key performance indicators">
          <div className="daily-report__kpi-card daily-report__kpi-card--return">
            <div className="daily-report__kpi-value" style={{ color: 'var(--success)' }}>
              {Number.isFinite(this.state.kpi.totalReturnPct) ? this.state.kpi.totalReturnPct : 0}%
            </div>
            <div className="daily-report__kpi-label">TOTAL RETURN</div>
            <FontAwesomeIcon icon={faChartLine} className="daily-report__kpi-icon" aria-hidden />
          </div>
          <div className="daily-report__kpi-card daily-report__kpi-card--profit">
            <div className="daily-report__kpi-value" style={{ color: 'var(--warning)' }}>
              ₹{(Number.isFinite(this.state.kpi.totalProfit) ? Math.round(this.state.kpi.totalProfit) : 0).toLocaleString('en-IN')}
            </div>
            <div className="daily-report__kpi-label">TOTAL PROFIT</div>
            <FontAwesomeIcon icon={faRupeeSign} className="daily-report__kpi-icon" aria-hidden />
          </div>
          <div className="daily-report__kpi-card daily-report__kpi-card--winrate">
            <div className="daily-report__kpi-value" style={{ color: 'var(--success)' }}>
              {this.state.kpi.winRate}%
            </div>
            <div className="daily-report__kpi-label">WIN RATE</div>
            <FontAwesomeIcon icon={faCheckCircle} className="daily-report__kpi-icon" aria-hidden />
          </div>
          <div className="daily-report__kpi-card daily-report__kpi-card--maxloss">
            <div className="daily-report__kpi-value" style={{ color: 'var(--danger)' }}>
              {this.state.kpi.maxLoss <= 0 ? `-₹${Math.abs(this.state.kpi.maxLoss).toLocaleString('en-IN')}` : `₹${this.state.kpi.maxLoss.toLocaleString('en-IN')}`}
            </div>
            <div className="daily-report__kpi-label">MAX LOSS</div>
            <FontAwesomeIcon icon={faExclamationTriangle} className="daily-report__kpi-icon" aria-hidden />
          </div>
        </section>
      </div>
    );
  }
}

export default DailyReport;